module.exports = __webpack_public_path__ + "static/media/airconditioner.34f6439d.svg";